import type { ImportHistoryItem } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';

import { useImportBlobDownload } from './use-import-blob-download';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Downloads an import's generated error report. */
export function useDownloadErrorReport(): UseMutationResult<void, Error, ImportHistoryItem> {
  return useImportBlobDownload(
    (api, importDoc) => api.downloadErrorReport(importDoc.id),
    'report.rejectedRows.downloadError',
  );
}
